import { useState, useCallback } from 'react';
import { useLocalMediaActions } from './useLocalMediaActions';

type UseRestartCallButtonReturnType = {
  isInProgress: boolean;
  restartMedia: () => Promise<void>;
};
/**
 * Restarts local media via parameterless `restart()` (access as `video`/`audio`;
 * publish flags merged from existing publisher settings).
 * @TODO Handle media error statuses when they got added.
 * @returns {UseRestartCallButtonReturnType}
 */
export function useRestartLocalMedia(): UseRestartCallButtonReturnType {
  const [isInProgress, setIsInprogress] = useState(false);

  const { restart } = useLocalMediaActions();

  const restartMedia = useCallback(async (): Promise<void> => {
    setIsInprogress(true);
    try {
      await restart();
    } finally {
      setIsInprogress(false);
    }
  }, [restart]);

  return {
    isInProgress,
    restartMedia,
  };
}
